export default __webpack_public_path__ + "static/media/lain-logo.ff50c2ad.png";